'use client';

import AccountHealthModalContent from 'src/components/AccountHealthModalContent';
import React, { useState } from 'react';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import useModal from 'src/components/Modals/hooks/useModal';
import ResponsiveModal from 'src/components/Modals/ResponsiveModal/ResponsiveModal';
import { MarginCategory } from '@drift-labs/sdk';
import { TabOption } from 'src/components/primitives/Tabs/types';

const TABS: TabOption<MarginCategory>[] = [
	{
		value: 'Maintenance',
		label: 'Maintenance Margin',
	},
	{
		value: 'Initial',
		label: 'Initial Margin',
	},
];

const AccountHealthModal = () => {
	const { hide } = useModal();
	const currentAccountName = useDriftAccountStore(
		(s) => s.getCurrentUserAccount()?.name || 'Account Health'
	);
	const [marginCategory, setMarginCategory] =
		useState<MarginCategory>('Maintenance');

	return (
		<ResponsiveModal.Container
			onClose={hide}
			// Use fixed width to prevent width from changing when switching tabs.
			className="sm:w-[809px]"
			dataTestId="account-health-modal"
		>
			<ResponsiveModal.Title
				tabs={TABS}
				activeTab={marginCategory}
				onTabChange={setMarginCategory}
				closeButtonTestId="account-health-modal-close"
			>
				{currentAccountName} Breakdown
			</ResponsiveModal.Title>
			<AccountHealthModalContent marginCategory={marginCategory} />
		</ResponsiveModal.Container>
	);
};

export default React.memo(AccountHealthModal);
